export default "__VITE_ASSET__CZ7_S13n__"